import { render, staticRenderFns } from "./DDT.vue?vue&type=template&id=6ddf0950&"
import script from "./DDT.vue?vue&type=script&lang=js&"
export * from "./DDT.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports